export default function PromoCodeIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">

            <path d="M23.5 15C21.843 15 20.5 13.657 20.5 12C20.5 10.344 21.843 9 23.5 9V4.5H0.5V9C2.156 9 3.5 10.344 3.5 12C3.5 13.657 2.156 15 0.5 15V19.5H23.5V15Z"></path>
            <path d="M7 16L15 8"></path>
            <path d="M8 10.5C8.82843 10.5 9.5 9.82843 9.5 9C9.5 8.17157 8.82843 7.5 8 7.5C7.17157 7.5 6.5 8.17157 6.5 9C6.5 9.82843 7.17157 10.5 8 10.5Z"></path>
            <path d="M14 16.5C14.8284 16.5 15.5 15.8284 15.5 15C15.5 14.1716 14.8284 13.5 14 13.5C13.1716 13.5 12.5 14.1716 12.5 15C12.5 15.8284 13.1716 16.5 14 16.5Z"></path>
            <circle r="0.5" transform="matrix(1 0 0 -1 18.5 7.5)"></circle>
            <circle r="0.5" transform="matrix(1 0 0 -1 18.5 10.5)"></circle>
            <circle r="0.5" transform="matrix(1 0 0 -1 18.5 13.5)"></circle>
            <circle r="0.5" transform="matrix(1 0 0 -1 18.5 16.5)"></circle>
        </svg>
    )
}